import { BottomSheetContent as UiBottomSheetContent, styled } from "@l2r-front/l2r-ui"

export const BottomSheetContent = styled(UiBottomSheetContent)(({ theme }) => ({
    padding: theme.spacing(0, 6, 0, 6),
}))